import axios from "axios";
import * as types from "../mutation-types";

// state
export const state = {
    ufs: null
};

// getters
export const getters = {
    ufs: state => state.ufs
};

// mutations
export const mutations = {
    [types.FETCH_UFS_SUCCESS](state, {ufs}) {
        state.ufs = ufs
    },
    [types.FETCH_UFS_FAILURE] (state) {
        state.ufs = null
    }
};

// actions
export const actions = {
    async fetchAllUfs({commit}) {
        try {
            const {data: {data}} = await axios.get("/api/ufs");

            commit(types.FETCH_UFS_SUCCESS, {ufs: data});
        } catch (e) {
            commit(types.FETCH_UFS_FAILURE);
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/ufs.js